import React from "react";

import {
  DocumentList,
  InfoPanel,
  Typography,
} from "@king-ict/eupisi-ui/components";
import { UploadFile } from "@king-ict/eupisi-ui/models";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { DocumentType } from "../../../models/Request/DocumentType";
import RequestStatus from "../../../models/Request/RequestStatusEnum";
import { Attachment } from "../../../models/Shared/Attachment";
import { RequestFormCard } from "../RequestComponents";

interface Props {
  canUploadRegistrationForm: boolean;
  handleUploadDocumentClick: (documentType: DocumentType) => void;
  attachments?: Attachment[];
  handleDocumentDownload: (doc: Attachment, type: DocumentType) => void;
  filesToUpload?: UploadFile[];
  handleRemoveTempUploadFile: (file: UploadFile) => void;
  requestStatusId: number;
}

export function ManualSigningContent({
  canUploadRegistrationForm,
  handleUploadDocumentClick,
  attachments,
  handleDocumentDownload,
  filesToUpload,
  handleRemoveTempUploadFile,
  requestStatusId,
}: Props) {
  const { t } = useTranslation();

  return (
    <>
      <RequestFormCard
        cardTitle={t("enrollmentStep.signedEnrollmentDocument")}
        showRefresh={canUploadRegistrationForm}
        refreshTitle={t("documentUpload.attachDocument")}
        onClickRefresh={
          canUploadRegistrationForm
            ? () => handleUploadDocumentClick(DocumentType.RegistrationForm)
            : undefined
        }
        key={DocumentType.RegistrationForm}
      >
        <Row>
          <Col md={6}>
            <Typography variant="baseBold" className="border-bottom">
              {t("enrollmentStep.DocumentsSent")}
            </Typography>
            <DocumentList
              documents={attachments ?? []}
              onDocumentClick={(doc) =>
                handleDocumentDownload(doc, DocumentType.RegistrationForm)
              }
              onRemoveClick={(doc) => console.log(doc)}
              removable={false}
            />
          </Col>

          {requestStatusId !== RequestStatus.Registered && (
            <Col md={6}>
              <Typography
                variant="baseBold"
                color="light"
                className="border-bottom"
              >
                {t("request.documentUpdateFileList")}
              </Typography>
              <DocumentList
                documents={filesToUpload ?? []}
                onRemoveClick={(doc) => handleRemoveTempUploadFile(doc)}
                removable={true}
              />
            </Col>
          )}
        </Row>
      </RequestFormCard>
    </>
  );
}
